import api from './api';

export interface SiteLead {
  id: number;
  tipo: string;
  nome: string | null;
  email: string | null;
  telefone: string | null;
  organizacao: string | null;
  assunto: string | null;
  mensagem: string | null;
  origem: string | null;
  extra: Record<string, unknown> | null;
  estado: 'novo' | 'contactado' | 'fechado';
  created_at: string;
}

export const leadsSiteService = {
  list: (params?: { tipo?: string; estado?: string }) =>
    api.get<{ success: boolean; data: SiteLead[] }>('/admin/leads', { params }),
  setEstado: (id: number, estado: SiteLead['estado']) =>
    api.put<{ success: boolean }>(`/admin/leads/${id}`, { estado }),
};

export default leadsSiteService;
